import React, { Component } from 'react';
import { ChangeDepartment } from './SizeGuide.css';
import Departments from '../../common/models/Departments';
import PropTypes from 'prop-types';

class SizeGuideDepartmentSwitch extends Component {
  render() {
    const { department, onClick } = this.props;
    const otherDepartment = Departments.getOppositeDepartment(department);

    if (!otherDepartment) {
      return null;
    }

    return (
      <ChangeDepartment
        onClick={() => {
          onClick && onClick();
        }}
      >
        View {Departments.getName(otherDepartment)}
      </ChangeDepartment>
    );
  }
}

SizeGuideDepartmentSwitch.propTypes = {
  department: PropTypes.string.isRequired,
  onToggle: PropTypes.func
};

export default SizeGuideDepartmentSwitch;
